import useFullscreenState from "helpers/useFullscreenState";
import { Fullscreen, FullscreenExit } from "mdi-material-ui";
import { SUPPORT_BROWSER_FULLSCREEN } from "providers/FullscreenStateProvider";
import React from "react";

import PlayerButton from "./PlayerButton";

// preferVideo: fullscreen the video itself, eg on a phone, whose own player fills the screen and rotates with it
export default function FullscreenButton({ video, preferVideo = false, color }) {
  const [fullscreen, fullscreenSet] = useFullscreenState();
  const requestFullScreen =
    // first, as an iPhone can have the standard call but only fullscreens video with its own
    (video?.webkitSupportsFullscreen ? video.webkitEnterFullscreen : null) ||
    video?.requestFullscreen ||
    video?.mozRequestFullScreen ||
    video?.msRequestFullscreen;
  const supportVideoFullscreen = video && !!requestFullScreen;

  return (
    <PlayerButton
      title="Fullscreen"
      color={color}
      onClick={() => {
        if (preferVideo && supportVideoFullscreen) return requestFullScreen.apply(video);
        // if browser supports fullscreen API, prefer to use it
        if (SUPPORT_BROWSER_FULLSCREEN) return fullscreenSet(!fullscreen);
        if (supportVideoFullscreen) return requestFullScreen.apply(video);
      }}
      icon={fullscreen ? <FullscreenExit /> : <Fullscreen />}
    />
  );
}
